// Fallback meal catalog mirror of /app/backend/server.py MEALS dict.
// Used when the /api/meals call fails (CORS, network, deploy gap, backend down).
// The menu MUST always render; customers should never see a broken page.
// Keep in sync with backend when meals change — both sources update together.

export const FALLBACK_MEALS = [
    {
        id: "griot_diri_djondjon",
        name: "Baked Pork with Black Rice & Vegetables",
        subtitle: "Tender · Seasoned · Satisfying",
        cuisine_emoji: "🇭🇹",
        diet_tag: "Signature",
        diet_tag_color: "#C1440E",
        price: 13.99,
        original_price: 13.99,
        description:
            "Our Baked Pork with Black Rice & Vegetables combines authentic Caribbean flavor with balanced meal prep nutrition. Featuring juicy seasoned baked pork, rich Haitian black rice, and vibrant mixed vegetables, this meal delivers bold taste, satisfying protein, and fresh ingredients in every bite.",
        nutrition: { calories: 630, protein: 40, carbs: 55, fat: 22 },
        ingredients: [
            "Caribbean-seasoned baked pork",
            "Haitian black rice (diri djondjon)",
            "Broccoli",
            "Carrots",
            "Bell peppers",
            "Onions",
            "Caribbean herbs & spices",
            "Fresh parsley",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/qayl2u3m_file_00000000a6f8722f8f9084cacb8d38c6.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/mzt1j4xp_Screenshot_20260522_095333_ChatGPT.jpg",
    },
    {
        id: "griot_pikliz_plantains",
        name: "Baked Chicken with White Rice & Vegetables",
        subtitle: "Clean · Flavorful · Satisfying",
        cuisine_emoji: "🍗",
        diet_tag: "Most Popular",
        diet_tag_color: "#F4A435",
        price: 14.99,
        original_price: 14.99,
        description:
            "Our Baked Chicken Meal delivers bold Caribbean flavor with a healthier twist. Featuring seasoned baked chicken leg & thigh, fluffy white rice, and vibrant mixed vegetables, this meal is crafted to keep you full, energized, and satisfied.",
        nutrition: { calories: 585, protein: 38, carbs: 55, fat: 18 },
        ingredients: [
            "Baked chicken leg & thigh",
            "Seasoned white rice",
            "Broccoli",
            "Carrots",
            "Bell peppers",
            "Green beans",
            "Caribbean herbs & spices",
            "Fresh parsley",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/d3ysg68z_file_00000000ca2872309c6abe06aa353ba3.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/cwhvk0c4_file_000000001f2c71f59aade078dace90cf.png",
    },
    {
        id: "black_rice_chicken_plantains",
        name: "Black Rice, Grilled Chicken & Mixed Vegetables",
        subtitle: "Healthy · Balanced · Caribbean Inspired",
        cuisine_emoji: "🥦",
        diet_tag: "High Protein · Healthy",
        diet_tag_color: "#2D6A4F",
        price: 15.99,
        original_price: 15.99,
        description:
            "Tender grilled chicken served over authentic Haitian black rice (diri djondjon) with a fresh mix of broccoli, carrots, bell peppers, and seasoned vegetables. Crafted with bold Caribbean flavor while keeping it balanced, clean, and satisfying.",
        nutrition: { calories: 570, protein: 44, carbs: 50, fat: 15 },
        ingredients: [
            "Diri djondjon (Haitian black mushroom rice)",
            "Grilled chicken breast",
            "Broccoli",
            "Carrots",
            "Bell peppers",
            "Seasoned mixed vegetables",
            "Caribbean herbs & spices",
            "Olive oil",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/jgkusxyd_file_000000005d1471f5ad278b124d3f66b5.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/2h4jxm8r_file_0000000003b071fda1d9461ad338c843.png",
    },
    {
        id: "plantains_fried_chicken",
        name: "Dominican Baked Chicken with Arroz Con Gandules & Vegetables",
        subtitle: "Bold · Authentic · Balanced",
        cuisine_emoji: "🇩🇴",
        diet_tag: "Dominican",
        diet_tag_color: "#C1440E",
        price: 13.99,
        original_price: 13.99,
        description:
            "Our Dominican Baked Chicken Meal brings authentic island flavor to healthy meal prep. Featuring seasoned baked chicken, traditional Arroz Con Gandules, and colorful mixed vegetables, this meal combines bold Dominican taste with balanced nutrition for a satisfying Caribbean-inspired experience.",
        nutrition: { calories: 580, protein: 42, carbs: 55, fat: 18 },
        ingredients: [
            "Dominican-style baked chicken",
            "Arroz con gandules (rice with pigeon peas)",
            "Broccoli",
            "Carrots",
            "Bell peppers",
            "Onions",
            "Sazón Dominicano",
            "Fresh herbs",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/qxjmu324_file_00000000f99c71fda09e4e6f12c9954e.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/jph3d45q_file_00000000db4871fd8ae02369f0190d9d.png",
    },
    {
        id: "premium_jerk_chicken_djondjon",
        name: "Premium Jerk Chicken with Diri Djon Djon",
        subtitle: "Slow-Marinated · Smoky · Heritage",
        cuisine_emoji: "🔥",
        diet_tag: "Premium",
        diet_tag_color: "#7B2D26",
        price: 16.99,
        original_price: 16.99,
        is_premium: true,
        description:
            "A chef's special: jerk-marinated chicken slow-roasted over Caribbean spices, plated on rich Haitian Diri Djon Djon (black mushroom rice) with a colorful blend of sautéed vegetables.",
        nutrition: { calories: 520, protein: 38, carbs: 58, fat: 14, fiber: 8 },
        ingredients: [
            "Jerk-marinated chicken thighs & drumsticks",
            "Diri Djon Djon (Haitian black mushroom rice)",
            "Sautéed broccoli, carrots & bell peppers",
            "Scotch bonnet · allspice · thyme",
            "Fresh scallions",
            "Caribbean herb blend",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/3vsccn9j_file_00000000fe1c720cbf64265ba48509ff.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/9rwfi19g_file_00000000a7a8720cb7f54eb8d23b283a.png",
    },
    {
        id: "premium_baked_salmon",
        name: "Premium Baked Salmon",
        subtitle: "Oven-Baked · Bold · Clean",
        cuisine_emoji: "🐟",
        diet_tag: "Premium",
        diet_tag_color: "#7B2D26",
        price: 16.99,
        original_price: 16.99,
        is_premium: true,
        description:
            "Caribbean-seasoned 6oz salmon fillet, oven-baked to flaky perfection, served with herb-roasted potatoes, fresh asparagus, and a lemon wedge. A premium plate engineered for clean protein and bold island flavor.",
        nutrition: { calories: 550, protein: 39, carbs: 52, fat: 20 },
        ingredients: [
            "6oz baked salmon",
            "Herb-roasted potatoes",
            "Fresh asparagus",
            "Olive oil & Caribbean herbs",
            "Lemon wedge",
            "Sea salt & cracked pepper",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/8jptdczs_file_00000000f03c722f8cd1c6e2c17a1f5d.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/duk3yihd_Screenshot_20260608_125518_ChatGPT.jpg",
    },
    {
        id: "premium_jerk_chicken_sweet_potato",
        name: "Premium Jerk Chicken Sweet Potato Bowl",
        subtitle: "Grilled · Balanced · Energizing",
        cuisine_emoji: "🍠",
        diet_tag: "Premium",
        diet_tag_color: "#7B2D26",
        price: 16.99,
        original_price: 16.99,
        is_premium: true,
        description:
            "5oz jerk chicken breast paired with roasted sweet potatoes, broccoli, carrots and peppers — lightly finished in avocado oil. A clean, high-protein power bowl.",
        nutrition: { calories: 510, protein: 42, carbs: 48, fat: 14 },
        ingredients: [
            "5oz jerk chicken breast",
            "Roasted sweet potatoes",
            "Broccoli",
            "Carrots",
            "Bell peppers",
            "Light avocado oil seasoning",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/trk1ktbg_file_00000000ca8871f68c407ce3ce03b192.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/1l3zff8h_file_00000000d6e471f5bacb74dc488bd979.png",
    },
    {
        id: "caribbean_caesar",
        name: "Caribbean Style Salad",
        subtitle: "Fresh · Flavorful · Caribbean",
        cuisine_emoji: "🥗",
        diet_tag: "High Protein · Low Cal",
        diet_tag_color: "#40916C",
        price: 12.99,
        original_price: 12.99,
        description:
            "Fresh Caribbean flavor without the heavy dressing. Our Caribbean Style Salad is packed with flame-grilled chicken, crisp vegetables, eggs, and natural flavor from lemon and olive oil — all crafted to keep it light, satisfying, and protein-packed.",
        nutrition: { calories: 450, protein: 42, carbs: 21, fat: 16 },
        ingredients: [
            "Grilled chicken breast",
            "Romaine lettuce",
            "Purple onions",
            "Tomatoes",
            "Shredded carrots",
            "Green peppers",
            "Hard-boiled eggs",
            "Lemon",
            "Olive oil or avocado oil",
            "Fresh herbs & Caribbean seasoning",
        ],
        image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/jnxdndhf_file_00000000527871f7845fb0236d82cb30.png",
        signature_image:
            "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/1wm013dn_file_00000000172c71f58d464ae22bc40925.png",
    },
];

// Decorate the static fallback so first-paint matches the API shape:
// premium plates → in_weekly_menu=false (default state until weekly menu loads)
// regular plates → in_weekly_menu=true, effective_min_quantity=1
// Premium meals no longer have a hard min_quantity — they follow the same
// off-menu min-3 rule as everything else.
FALLBACK_MEALS.forEach((m) => {
    if (m.is_premium) {
        m.in_weekly_menu = false;
        m.effective_min_quantity = 3;
    } else {
        m.in_weekly_menu = true;
        m.effective_min_quantity = 1;
    }
});

export const FALLBACK_DELIVERY_FEE = 9.99;

export const FALLBACK_FAMILY_CONFIG = {
    image: "https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/1n2kij7n_file_000000007fa871f58cb6785e88468174.png",
    min_members: 4,
    max_members: 15,
    formula: "meal_price × (members − 1)",
};
